import { render, staticRenderFns } from "./NotificationDelete.vue?vue&type=template&id=21b1f6b3&scoped=true&"
import script from "./NotificationDelete.vue?vue&type=script&lang=js&"
export * from "./NotificationDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b1f6b3",
  null
  
)

export default component.exports